import { API_URL } from 'config'

export type User = {
  username: string
  token: string
}

export const currentUser = () => {
  const userString = localStorage.getItem('currentUser')
  if (!userString) {
    return null
  }

  return JSON.parse(userString) as User
}

export const isAuthenticated = () => {
  return !!currentUser()?.token
}

export const authHeader = (): { Authorization: string } | {} => {
  const user = currentUser()
  return user && user.token ? { Authorization: `Bearer ${user.token}` } : {}
}

export const login = async (username: string, password: string) => {
  const [encodedUser, encodedPassword] = [
    encodeURIComponent(username),
    encodeURIComponent(password),
  ]

  const options = {
    method: 'POST',
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
    },
    body: `username=${encodedUser}&password=${encodedPassword}`,
  }

  try {
    const response = await fetch(`${API_URL}/login/token`, options)
    if (!response.ok) {
      throw new Error(
        `Login error, ${response.status} - ${response.statusText}`
      )
    }
    const data = await response.json()

    const user: User = {
      username,
      token: data.access_token,
    }

    localStorage.setItem('currentUser', JSON.stringify(user))

    return true
  } catch (error) {
    console.error(error)
    return false
  }
}

export const logout = () => {
  if (localStorage.getItem('currentUser')) {
    localStorage.removeItem('currentUser')
    window.location.reload()
  }
}

export const testToken = async () => {
  const options = { headers: { ...authHeader() } }

  try {
    const response = await fetch(`${API_URL}/login/test-token`, options)
    return response.ok
  } catch (error) {
    console.error('Login token error', error)
    return false
  }
}
